import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Flooring Installation',
        content: 'Installing new hardwood floors or refinishing existing ones to revitalize their appearance.',
        paragraphs: [
            'Transform your interiors with our professional flooring installation services. Whether you’re installing new hardwood or refinishing existing floors, we deliver exceptional craftsmanship tailored to your space.',
            'Our skilled team ensures precision and quality at every step, giving your floors a flawless finish and long-lasting appeal.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Premium Materials',
            'Flawless Finish',
            'Dust-Free Sanding',
            'Custom Staining Options',
            'Durable Sealants'
        ],
        procedure: [
            'On-Site Assessment',
            'Material Selection',
            'Subfloor Preparation',
            'Precise Installation',
            'Finishing and Cleanup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does flooring installation take?',
                content: 'Installation times vary depending on the size of the space and the type of flooring. Most standard projects are completed within 2–5 days.'
            },
            {
                id: 2,
                heading: 'Can you install over existing flooring?',
                content: 'In some cases, yes. We’ll assess your current floors to determine if installation over them is feasible or if removal is needed.'
            },
            {
                id: 3,
                heading: 'Do you offer refinishing services?',
                content: 'Absolutely. We offer professional refinishing to restore the original beauty of worn-out hardwood floors.'
            },
            {
                id: 4,
                heading: 'What types of flooring do you install?',
                content: 'We specialize in hardwood flooring but also install laminate, vinyl, and engineered wood options to suit various preferences and budgets.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Tile Installation',
        content: 'Professional installation of tiles for bathrooms, kitchens, and other areas.',
        paragraphs: [
            'Enhance the look and durability of your space with expert tile installation. We specialize in laying tiles for bathrooms, kitchens, backsplashes, floors, and walls with detailed craftsmanship.',
            'From material selection to final grouting, our team ensures accurate alignment, clean finishes, and long-lasting performance.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Wide Tile Variety',
            'Precision Alignment',
            'Waterproof Solutions',
            'Durable Grouting',
            'Custom Layouts'
        ],
        procedure: [
            'Surface Preparation',
            'Tile Layout Planning',
            'Tile Cutting & Placement',
            'Grouting & Sealing',
            'Final Inspection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of tiles do you install?',
                content: 'We install ceramic, porcelain, glass, marble, and natural stone tiles, tailored to your space and design vision.'
            },
            {
                id: 2,
                heading: 'How long does tile installation take?',
                content: 'The time varies based on the area size and tile complexity. Most projects are completed within 1–4 days.'
            },
            {
                id: 3,
                heading: 'Do you offer waterproofing solutions?',
                content: 'Yes, we include waterproofing treatments for wet areas like bathrooms and kitchens to prevent water damage.'
            },
            {
                id: 4,
                heading: 'Can you help with tile selection?',
                content: 'Absolutely! We provide guidance on choosing the right tile materials, sizes, and colors for your project.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Paving Services',
        content: 'Providing paving solutions for driveways, walkways, and outdoor spaces.',
        paragraphs: [
            'Transform your outdoor areas with our professional paving services. We specialize in creating durable and visually appealing surfaces for driveways, walkways, patios, and more.',
            'Using high-quality materials and precision techniques, our team delivers paving solutions that stand up to the elements while enhancing your property’s exterior.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Durable Materials',
            'Weather-Resistant Surfaces',
            'Custom Designs',
            'Slip-Resistant Finishes',
            'Low Maintenance Solutions'
        ],
        procedure: [
            'Site Evaluation',
            'Design & Material Selection',
            'Ground Preparation',
            'Paving Installation',
            'Final Touches & Inspection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of paving materials do you offer?',
                content: 'We offer concrete, asphalt, brick, and natural stone paving options tailored to your design and budget.'
            },
            {
                id: 2,
                heading: 'How long does a paving project take?',
                content: 'Project timelines vary based on area size and design complexity. Most installations are completed within 2–5 days.'
            },
            {
                id: 3,
                heading: 'Is the paving slip-resistant?',
                content: 'Yes, we use materials and finishes that enhance traction and reduce the risk of slips, especially in wet conditions.'
            },
            {
                id: 4,
                heading: 'Do you provide paving maintenance services?',
                content: 'We offer sealing, repairs, and cleaning services to keep your paved surfaces looking great and performing well.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Floor Repair',
        content: 'Repairing and restoring damaged or worn-out floors to their original condition.',
        paragraphs: [
            'Bring life back to your floors with our professional repair services. Whether it’s hardwood, tile, or laminate, we fix cracks, scratches, water damage, and more with precision and care.',
            'Our team assesses the extent of the damage and applies the most effective restoration techniques, ensuring a seamless finish and long-lasting results.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Surface Restoration',
            'Crack & Gap Filling',
            'Scratch & Dent Repair',
            'Color Matching',
            'Durability Enhancement'
        ],
        procedure: [
            'Damage Assessment',
            'Repair Planning',
            'Surface Preparation',
            'Repair & Restoration',
            'Final Inspection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can all types of flooring be repaired?',
                content: 'Yes, we repair hardwood, laminate, tile, vinyl, and other types of flooring using materials and techniques suited to each surface.'
            },
            {
                id: 2,
                heading: 'How do you match the repaired area with the existing floor?',
                content: 'We use precision color matching, texturing, and finishing techniques to ensure the repaired area blends seamlessly with the surrounding floor.'
            },
            {
                id: 3,
                heading: 'Do I need to vacate the room during repairs?',
                content: 'In most cases, minimal disruption is caused. We recommend keeping the area clear during repairs to ensure safety and efficiency.'
            },
            {
                id: 4,
                heading: 'How long does a typical floor repair take?',
                content: 'Timeframes vary depending on the type and extent of damage, but most repairs are completed within a few hours to a day.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Grout Cleaning',
        content: 'Thorough cleaning and restoration of grout lines to enhance the appearance of tiled surfaces.',
        paragraphs: [
            'Restore the original look of your tiled areas with our professional grout cleaning service. We remove dirt, grime, and mold that standard cleaning methods can’t tackle.',
            'Our advanced equipment and cleaning solutions penetrate deep into grout lines, ensuring a fresh, sanitized, and revitalized finish that enhances the overall appearance of your space.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Deep Cleaning',
            'Stain & Mold Removal',
            'Restored Appearance',
            'Sanitized Surfaces',
            'Protective Sealing Options'
        ],
        procedure: [
            'Grout Inspection',
            'Pre-Treatment Application',
            'Deep Cleaning Process',
            'Rinse & Extraction',
            'Optional Sealing'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How often should grout be cleaned professionally?',
                content: 'We recommend professional grout cleaning every 12–18 months, depending on foot traffic and exposure to moisture or dirt.'
            },
            {
                id: 2,
                heading: 'Can you remove old and deep stains from grout?',
                content: 'Yes, our specialized cleaning agents and equipment can remove even stubborn, set-in stains and restore grout to its original color.'
            },
            {
                id: 3,
                heading: 'Do you offer sealing after grout cleaning?',
                content: 'Yes, we offer grout sealing to protect against future stains and moisture, extending the life of your tiled surfaces.'
            },
            {
                id: 4,
                heading: 'Is the grout cleaning process safe for all tiles?',
                content: 'Absolutely. We use techniques and products that are safe and effective for ceramic, porcelain, and natural stone tiles.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Concrete Polish',
        content: 'Polishing and sealing concrete floors to achieve a glossy and durable finish.',
        paragraphs: [
            'Enhance the strength and aesthetic appeal of your concrete floors with our expert polishing services. We use advanced grinding and polishing techniques to create a sleek, modern finish.',
            'Our sealing options provide added protection against stains, moisture, and wear, making your concrete surfaces both beautiful and long-lasting.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Glossy Finish',
            'Stain Resistance',
            'Low Maintenance',
            'Long-Lasting Durability',
            'Modern Aesthetic'
        ],
        procedure: [
            'Surface Preparation',
            'Grinding & Smoothing',
            'Polishing Process',
            'Sealing Application',
            'Final Inspection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does concrete polishing take?',
                content: 'The process typically takes one to two days, depending on the area size and desired finish level.'
            },
            {
                id: 2,
                heading: 'Is polished concrete slippery?',
                content: 'Despite its glossy appearance, polished concrete provides good slip resistance and can be treated for additional grip if needed.'
            },
            {
                id: 3,
                heading: 'How durable is polished concrete?',
                content: 'Polished concrete is extremely durable and resistant to heavy foot traffic, stains, and abrasion when properly sealed.'
            },
            {
                id: 4,
                heading: 'Do you offer different finish levels?',
                content: 'Yes, we offer various finish levels, from satin to high-gloss, depending on your design preference and usage needs.'
            }
        ]
    }

];

export default services;